import handleCart from './handleCart.js'
import { combineReducers } from 'redux';

const rootReducers = combineReducers({
   handleCart,
})

export default rootReducers